import { forwardRef } from 'react';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SettingsModule = /*#__PURE__*/forwardRef(({
  header,
  description,
  body,
  error,
  validationMessage
}, ref) => {
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    children: /*#__PURE__*/_jsx(UIFormControl, {
      label: header,
      error: error,
      validationMessage: validationMessage,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [description && /*#__PURE__*/_jsx("div", {
          className: "m-bottom-3",
          children: description
        }), body]
      })
    })
  });
});
export default SettingsModule;